import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Input,
  CardBody,
  FormGroup,
  Label,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link, useNavigate } from "react-router-dom";
import pic1 from "../../assets/images/noti-pic.png";
import find from "../../assets/find.svg";
import avatar3 from "../../assets/images/personPlaceholder.png";

import { get, put } from "../../api/axios";
import { toast } from "react-toastify";
import TimeAgo from "react-timeago";
import endpoints from "../../api/endpoints";
import { useSelector } from "react-redux";
import Placeholder from "../../assets/images/Placeholder.gif";
const NotificationsList = () => {
  document.title = "Notifications | Elevated - Admin Dashboard";
  const [notificationList, setNotificationList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreNotifications, setHasMoreNotifications] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [filterFlag, setFilterFlag] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const itemsPerPage = 6;

  const notificationRoutes = {
    VIDEO_POST: (id) => `/videodetail/${id}`,
    COMMENT: (id) => `/videodetail/${id}`,
    VOTE: (id) => `/videodetail/${id}`,
    blog: (id) => `/blog-details/${id}`,
    TOPIC: (id) => `/header-video-details/${id}`,
    CHALLENGE: (id) => `/challengedetail/${id}`,
    WINNER: (id) => `/winnerdetail/${id}`,
    EVENT: (id) => `/eventdetail/${id}`,
    APPROVAL: (id) => `/approvaldetail/${id}`,
  };

  const getData = async (page) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.notification}?limit=6&page=${page}&filter=${
          filterFlag ? "unread" : "read"
        }`
      );
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
      if (response.status === 200) {
        const newNotifications = response.data.data;
        setNotificationList(newNotifications);
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);
  const markNotification = async (notification) => {
    const { id: notificationId, type, data } = notification;
    try {
      const response = await put(
        `${endpoints.notification}/read/${notificationId}`
      );
      if (response.status === 200) {
        getData(currentPage);
        // const route = notificationRoutes[type];
        // if (route) {
        //   navigate(route(data?.id));
        // } else {
        //   toast.info("Unknown notification type");
        // }
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error marking notification as read:", error);
    }
  };
  const { appRole } = useSelector((state) => {
    return state.auth.currentUser;
  });
  const markAllHandle = async () => {
    try {
      const response = await put(`${endpoints.notification}/read`);
      if (response.status === 200) {
        toast.success("All notifications marked as read");
        if (appRole == "admin" || appRole == "staff") {
          navigate("/dashboard");
        } else {
          navigate("/gymDashboard");
        }
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error marking all notifications as read:", error);
    }
  };
  useEffect(() => {
    getData(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm]);

  return (
    <section id="user-profile">
      <Card className="rounded-4 mx-2">
        <CardBody>
          <Row className="g-0">
            <Col lg={12}>
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                <div className="d-flex flex-row  justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0 ">
                  <span className=" font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 d-md-block">
                    Notifications
                  </span>
                </div>
                <div className="d-flex flex-row ff-sora justify-content-end align-items-center gap-2 w-100 mt-2 mt-sm-0">
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={filterFlag}
                      onClick={() => {
                        setFilterFlag(!filterFlag);
                        getData(currentPage);
                      }}
                    />
                    <Label check>Unread</Label>
                  </FormGroup>
                  <Button
                    color="white"
                    className="me-2 rounded-pill1"
                    onClick={markAllHandle}
                  >
                    Mark all as read
                  </Button>
                </div>
              </div>
              {/* <div className="margin-video-vaults d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                <div>
                  <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
                    Notifications
                  </h2>
                </div>
                <div className="text-end mb-0 pb-1">
                  <Button
                    color="white"
                    className="me-2 rounded-pill1"
                    onClick={markAllHandle}
                  >
                    Mark all as read
                  </Button>
                </div>
              </div> */}
              <div
                style={{
                  height: notificationList?.length > 0 ? "500px" : "auto",
                }}
              >
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border"
                      style={{
                        width: "3rem",
                        height: "3rem",
                        color: "#3BABA6",
                      }}
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : notificationList.length === 0 ? (
                  <></>
                ) : (
                  notificationList.map((item) => (
                    <div
                      className="notification-item mb-2 position-relative rounded-3 px-3 py-2"
                      key={item?._id}
                      onClick={() => {
                        markNotification(item);
                        if (item.data.type == "blog") {
                          navigate(`/blog-details`, {
                            state: {
                              blogData: { data: { id: item.data.id } },
                            },
                          });
                        }
                      }}
                      style={
                        !item.readStatus
                          ? {
                              backgroundColor: "#f8f9fa",
                              borderBottom: "1px solid #d6cece",
                            }
                          : {}
                      }
                    >
                      {!item.readStatus && (
                        <i
                          className="fa fa-circle position-absolute end-0 font-size-10 marker-px pe-2"
                          aria-hidden="true"
                        ></i>
                      )}
                      <Row className="align-items-start">
                        <Col xs="auto">
                          <div className="cursor-pointer">
                            <img
                              src={
                                item?.sender?.additionalInfo?.profileImage
                                  ? `${process.env.REACT_APP_IMG_URL}${item?.sender?.additionalInfo?.profileImage}`
                                  : avatar3
                              }
                              className="rounded-circle avatar-xs"
                              alt="user-pic"
                            />
                          </div>
                        </Col>
                        <Col>
                          <h4 className="fw-normal font-size-14 ff-sora mt-0 mb-1 cursor-pointer">
                            {item.sender?.firstName} {item.sender?.lastName}
                          </h4>
                          <p className="mb-0 float-end fw-normal font-size-12 ff-sora text-secondary">
                            <TimeAgo date={item.createdAt} />
                          </p>
                          <div className="font-size-12 fw-normal  ff-sora text-secondary cursor-pointer">
                            <p className="mb-1 ">
                              {item.title}
                              <span className="badge ms-2 font-size-12 fw-normal ff-sora text-bg-secondary">
                                {item.type}
                              </span>
                            </p>

                            <div className="mt-1 ps-2 border-start border-2 border-success">
                              <span className="fw-normal font-size-14 ff-sora text-secondary cursor-pointer">
                                {item.body}
                              </span>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))
                )}
              </div>
              {!loading && notificationList.length === 0 && (
                <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                  <img
                    src={Placeholder}
                    alt="No record placeholder"
                    className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                  />
                  <p className="mt-3 ff-sora font-size-16 fw-normal">
                    No Record Found!
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div
        className="d-flex px-3 justify-content-between align-items-center"
        style={{
          height: "40px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div>
          <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
            {`Showing ${Math.min(
              (currentPage - 1) * itemsPerPage + itemPerPage
            )} of ${totalItems}`}
          </span>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            style={{
              width: "40px",
              height: "40px",
              color: "#1f1f1f",
              borderWidth: "1px",
              borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
              background: "#f5f5f5",
              borderRadius: "80px",
            }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lt;
          </Button>
          {[...Array(totalPages).keys()]
            .slice(
              Math.max(0, currentPage - 2),
              Math.min(totalPages, currentPage + 1)
            )
            .map((page) => (
              <Button
                key={page + 1}
                onClick={() => handlePageChange(page + 1)}
                style={{
                  width: "40px",
                  height: "40px",
                  color: currentPage === page + 1 ? "white" : "#1f1f1f",
                  background: currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                  marginLeft: "10px",
                  marginRight: "10px",
                  borderRadius: "80px",
                  border: 0,
                }}
                className={currentPage === page + 1 ? "active" : ""}
              >
                {page + 1}
              </Button>
            ))}
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              width: "40px",
              height: "40px",
              color: "#1f1f1f",
              borderWidth: "1px",
              borderColor: currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
              background: "#f5f5f5",
              borderRadius: "80px",
            }}
          >
            &gt;
          </Button>
        </div>
      </div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </section>
  );
};

export default NotificationsList;
